<template>
  <div class="feedback">
    <div class="feedback__wrapper">
      <button @click="$emit('close-modal')" class="feedback__close">
        <XIcon class="feedback__close--icon" />
      </button>
      <h1 class="feedback__title">{{ title }}</h1>
      <p class="feedback__subtitle">
        <slot></slot>
      </p>
      <textarea
        class="ine-input feedback__textarea"
        v-model="message"
        :placeholder="feedbackHolder"
        rows="5"
      ></textarea>
      <button
        :disabled="!message"
        @click="sendFeedback()"
        class="btn btn--primary feedback__cta"
      >
        Submit
      </button>
    </div>
  </div>
</template>
<script>
import { XIcon } from 'vue-feather-icons'

export default {
  name: 'Feedback',
  components: {
    XIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    feedbackHolder: {
      type: String,
      required: false,
      default: () => {
        return ''
      },
    },
  },
  data: () => {
    return {
      message: '',
    }
  },
  methods: {
    sendFeedback() {
      this.$emit('give-feedback', this.message)
      this.$emit('close-modal')
    },
  },
}
</script>
<style lang="scss" scoped>
.feedback {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 220;
  overflow-y: scroll;
  background: #00000080 0% 0% no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  display: flex;
  justify-content: center;
  align-items: center;
  &__wrapper {
    position: relative;
    padding: 30px 30px 60px;
    background: #222222;
    border-radius: 35px;
    min-height: 400px;
    text-align: center;
    color: var(--white);
    @include tablet {
      padding: 70px;
    }
  }
  &__title {
    text-align: center;
    font-size: 40px;
    line-height: 52px;
    font-weight: var(--font-bold);
    letter-spacing: 0px;
  }
  &__subtitle {
    text-align: center;
    color: var(--light-blue-gray);
    font-size: rem(18px);
    line-height: 24px;
    letter-spacing: -0.44px;
    max-width: 800px;
  }
  &__close {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 0;
    top: 0;
    background: none;
    border: none;
    cursor: pointer;
    margin: 20px;
    &--icon {
      stroke: var(--white);
    }
  }
  &__textarea {
    width: 100%;
    background: linear-gradient(
      111.02deg,
      rgba(18, 18, 18, 0.7) 3.86%,
      rgba(18, 18, 18, 0) 107.96%
    );
    border-radius: 10px;
    padding: 30px;
    color: var(--light-blue-gray);
    margin-top: 30px;
    margin-bottom: 50px;
    min-height: 160px;
  }
}
</style>
